<template lang="pug">
.title-text(:id='id')
    label.title-label-text {{ label }}
</template>

<script>
export default {
    name: 'TitleComponent',

    props: {
        id: {
            type: String,
            default: () => `title-${Math.ceil(Math.random() * 10000)}`,
        },

        label: {
            type: String,
            default: '',
        },
    },
};
</script>

<style>
.title-text {
    padding: 3px;
    text-align: left;
    font-size: 25px;
    color: var(--primary-green);
}
</style>
